import { Component, Input } from '@angular/core';
import { BlogPost } from '../blog-post';
import { blogPostValidator } from '../new-blog-post/blog-validation.directive';
import { FormBuilder, FormControl } from '@angular/forms';
import { BlogService } from '../blog.service';

@Component({
  selector: 'app-selected-blog-post',
  templateUrl: './selected-blog-post.component.html',
  styleUrls: ['./selected-blog-post.component.css']
})
export class SelectedBlogPostComponent {

  @Input() selectedBlogPost?: BlogPost

  constructor(private formBuilder: FormBuilder, private blogPostService: BlogService) { }

  ngOnChanges() {
    this.resetForm()
  }

  editingBlogPost = false

  newFile: File | undefined = undefined
  newFileName: string | undefined

  blogPostForm = this.formBuilder.group({
    title: [''],
    content: [''],
    author: [''],
  }, { validators: blogPostValidator })

  titleControl = <FormControl>this.blogPostForm.get('title');
  contentControl = <FormControl>this.blogPostForm.get('content');
  authorControl = <FormControl>this.blogPostForm.get('author');


  editBlogPost() {
    this.editingBlogPost = true
    this.blogPostService.keepFocus = true
  }

  removeBlogPost() {
    this.blogPostService.deleteBlogPost(this.selectedBlogPost!!)
  }

  cancelUserEditing() {
    this.resetForm()
    this.editingBlogPost = false
    this.blogPostService.keepFocus = false
  }

  resetForm() {
    this.titleControl.setValue(this.selectedBlogPost!!.title)
    this.contentControl.setValue(this.selectedBlogPost!!.content)
    this.authorControl.setValue(this.selectedBlogPost!!.author)
    this.newFile = undefined
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      if (file.type == "image/png" || file.type == "image/jpeg") {
        this.newFile = file
        this.newFileName = file.name
      } else {
        alert(`Error: Invalid File Type - ${file.name}`)
        return
      }
    }
  }

  removeFile() {
    this.newFile = undefined
    this.newFileName = undefined
  }

  cancelClicked() {
    this.blogPostService.addBlogPostCancelled()
    this.editingBlogPost = false
  }

  submitBlogPostEdits() {
    const editedBlogPost = this.createBlogPostFromForm()
    if (JSON.stringify(editedBlogPost) === JSON.stringify(this.selectedBlogPost) && this.newFile == undefined) {
      this.cancelUserEditing()
      alert("No changes made")
      return
    }
    this.blogPostService.updateBlogPost(editedBlogPost, this.newFile)
  }

  createBlogPostFromForm(): BlogPost {
    const uid = this.selectedBlogPost?.uid!!
    const title = this.blogPostForm.value.title!!
    const content = this.blogPostForm.value.content!!
    const date = this.selectedBlogPost?.date!!
    const author = this.blogPostForm?.value.author!!
    return ({uid: uid, title: title, content: content, date: date, author: author}) as BlogPost
  }

}
